require('./horizontalLoader.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

class HorizontalLoader extends React.Component {
    render() {
        const loaderClassNames = classNames('horizontal-loader', this.props.className);

        return (

            <div className={loaderClassNames}>
                <ul className="horizontal-loader__circles">
                    <li className={classNames('horizontal-loader__circle', 'horizontal-loader__circle--first')}></li>
                    <li className={classNames('horizontal-loader__circle', 'horizontal-loader__circle--second')}></li>
                    <li className={classNames('horizontal-loader__circle', 'horizontal-loader__circle--third')}></li>
                </ul>
            </div>
        );
    }
}

HorizontalLoader.propTypes = {
    className: PropTypes.string
}

module.exports = HorizontalLoader;
